import { WelcomeState } from './types';
import { SegmentDefinition } from '@fullstory/proto/fs/api/segment';
import { isAllTime } from '@fullstory/search-shared';
import {
  QueryCacheOptions,
  SearchieMatchingUsersData,
  SearchieTimeRangeCountsData,
} from '@fullstory/proto/fs/services/alexa';
import { Duration, int64 } from '@fullstory/proto/google/protobuf';

export const SEARCHIE_REQUEST_BATCH_SIZE = 3;

// USERLIST_GRANULARIZATION is the "gran" param value in milliseconds for
// MatchingUsers and TimeRangeCounts.
export const USERLIST_GRANULARIZATION = 30 * 1000; // 30 second granularization

// Extracts the welcome state from matching users data for the given segment.
// If the returned value is null, the welcome state needs to be extracted from
// time range counts data for the segment.
export function welcomeStateFromMatchingUsers(
  muData: SearchieMatchingUsersData | null | undefined,
): WelcomeState | null {
  // If numUsers is set and non zero, we have some matching data.
  // But to use the welcome state from matching users, we also need the full events count (0 is okay, but negative is not).
  // Negative num events indicates matching users couldn't gather session and event counts and that time range counts is required.
  return int64.toNumber(muData?.matchingCounts?.numUsers) &&
    int64.toNumber(muData?.matchingCounts?.numEvents) >= 0
    ? WelcomeState.HAS_MATCHING
    : null;
}

// Extracts the welcome state from time range counts data for the given scope.
// If the returned value is null, the welcome state needs to be extracted from
// all-time time range counts data.
export function welcomeStateFromTimeRangeCounts(
  trcData: SearchieTimeRangeCountsData | null | undefined,
  segmentDefinition: SegmentDefinition | null | undefined,
): WelcomeState | null {
  // No data or no users
  if (!int64.toNumber(trcData?.totalCounts?.numUsers)) {
    return !isAllTime(segmentDefinition) ? null : WelcomeState.EMPTY_ORG;
  }
  // at this point, trcData.TotalUsers > 0, so we know that the org at least
  // has sessions
  if (!int64.toNumber(trcData?.matchingCounts?.numUsers)) {
    return WelcomeState.HAS_SESSIONS;
  }
  return WelcomeState.HAS_MATCHING;
}

export const skipCacheOpts: QueryCacheOptions = {
  getIfAgeLessThan: Duration.fromMillis(0),
  computeIfOlderThan: Duration.fromMillis(0),
  skipCache: true,
  queue: QueryCacheOptions.Queue.QUEUE_INVALID,
};
